import React from 'react'

function SubTitle({text}) {
  return (
    <div>
        <p className='font-Playfair font-bold text-4xl'>{text}</p>
    </div>
  )
}

export default SubTitle